<template>
  <div class="user-operation__forget-password">
    <h1 class="user-operation__title">
      <img :src="companyInfo.logo" alt="logo">
      <span>忘记密码</span>
    </h1>
    <el-form label-width="0" :model="forgetPasswordFormModel" :rules="rules"
             class="user-operation__forget-password-form" ref="forgetPasswordForm">
      <el-form-item prop="cellphone" ref="cellphone">
        <el-input type="tel" placeholder="请输入手机号" v-model="forgetPasswordFormModel.cellphone" :maxlength="11"
                  @change="allowSendingVerifyCode"></el-input>
      </el-form-item>
      <el-form-item class="user-operation__sms-validate-code" prop="SMSVerifyCode">
        <el-input placeholder="请输入短信验证码" v-model="forgetPasswordFormModel.SMSVerifyCode"
                  :readonly="!isAllowSendingVerifyCode" :maxlength="6"></el-input>
        <el-button type="primary" size="mini" class="user-operation__sms-button"
                   :disabled="SMSVerificationCodeBtn.disabled" :loading="isLoadingSMSVerifyCode"
                   @click="getSMSVerificationCode">{{SMSVerificationCodeBtn.text}}
        </el-button>
      </el-form-item>
      <el-form-item prop="password">
        <el-input type="password" placeholder="请输入密码" v-model="forgetPasswordFormModel.password"></el-input>
      </el-form-item>
      <el-form-item prop="confirmPassword">
        <el-input type="password" placeholder="请再次输入密码" v-model="forgetPasswordFormModel.confirmPassword"></el-input>
      </el-form-item>
    </el-form>
    <el-button type="primary" :loading="isLoading" class="user-operation__forget-password-submit"
               @click.enter="submitForm">
      确定
    </el-button>
  </div>
</template>
<script>
  import api from '../../vuex/api'
  import { mapGetters, mapActions } from 'vuex'
  import * as types from '../../vuex/types'

  export default {
    data () {
      const assignValidator = (type, trigger = 'blur') => Object.assign({
        required: true,
        trigger
      }, {
        validator: (rules, value, callback, source, options) => {
          this.$store.dispatch(type, {rules, value, callback, source, options})
        }
      })
      return {
        isLoading: false,
        publicKey: '',
        isAllowSendingVerifyCode: false,
        isLoadingSMSVerifyCode: false,
        isCounting: false,
        SMSVerificationCodeBtn: {
          disabled: true,
          text: '获取验证码'
        },
        rules: {
          cellphone: [assignValidator(types.VERIFY_CELLPHONE)],
          SMSVerifyCode: [{
            required: true,
            trigger: 'blur',
            message: '请填写收到的短信验证码'
          }],
          password: [assignValidator(types.VERIFY_REGISTER_PASSWORD)],
          confirmPassword: [{
            required: true,
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (value === '') {
                callback(new Error('请再次输入密码'))
              } else if (value !== this.forgetPasswordFormModel.password) {
                callback(new Error('两次输入密码不一致!'))
              } else {
                callback()
              }
            }
          }]
        },
        forgetPasswordFormModel: {
          cellphone: '',
          SMSVerifyCode: '',
          password: '',
          confirmPassword: ''
        }
      }
    },
    computed: {
      ...mapGetters({
        ajaxBaseUrl: types.GET_AJAX_BASE_URL,
        companyInfo: types.GET_COMPANY_INFO
      })
    },
    methods: {
      ...mapActions({
        forgetPassword: types.FORGET_PASSWORD,
        setAlertMessage: types.SET_FAIL_MESSAGE,
        getGenerateRSAPublicKey: types.GET_GENERATE_RSA_PUBLIC_KEY
      }),
      allowSendingVerifyCode (val) {
        if (this.isCounting === false) {
          this.isAllowSendingVerifyCode = val.trim() !== ''
          this.SMSVerificationCodeBtn = {
            disabled: val.trim() === '',
            text: '获取验证码'
          }
        }
      },
      getSMSVerificationCode () {
        // 注册与忘记密码的短信验证倒计时不需要共用，需要就将相关操作扔去action，现在这样就直接请求，降低复杂度
        this.isLoadingSMSVerifyCode = true
        this.$refs.forgetPasswordForm.validateField('cellphone')
        if (this.$refs.cellphone.validateState !== 'error') {
          api.getSMSVerificationCode({
            mobile: this.forgetPasswordFormModel.cellphone,
            isForRegister: false
          }).then((res) => {
            const resData = res.data
            let countDownTime = 60
            if (Number(resData.code) === 0) {
              const countDown = setInterval(() => {
                this.isLoadingSMSVerifyCode = false
                countDownTime -= 1

                if (countDownTime !== 0) {
                  this.SMSVerificationCodeBtn = {
                    disabled: true,
                    text: `${countDownTime}秒后获取`
                  }
                } else {
                  // if (this.isCounting === false) {
                    this.SMSVerificationCodeBtn = {
                      disabled: false,
                      text: '获取验证码'
                    }
                    clearInterval(countDown)
                  // }
                  this.isCounting = false
                }
              }, 1000)
            } else {
              this.isLoadingSMSVerifyCode = false
              this.setAlertMessage({
                show: true,
                content: resData.result
              })
            }
          }).catch((error) => {
            if (error) {
              this.isLoadingSMSVerifyCode = false
            } else {
              this.isLoadingSMSVerifyCode = false
            }
          })
        } else {
          this.isLoadingSMSVerifyCode = false
          this.SMSVerificationCodeBtn = {
            disabled: true,
            text: '获取验证码'
          }
        }
      },
      submitForm () {
        this.$refs.forgetPasswordForm.validate((valid) => {
          if (valid) {
            const form = this.forgetPasswordFormModel
            this.isLoading = true
            this.isCounting = true
            const encrypt = new JSEncrypt()
            encrypt.setPublicKey(this.publicKey)
            const _password = encodeURI(encrypt.encrypt(form.password))
            const _confirmPassword = encodeURI(encrypt.encrypt(form.confirmPassword))
            this.forgetPassword({
              mobile: form.cellphone,
              validCode: form.SMSVerifyCode,
              password: _password,
              confirmPassword: _confirmPassword
            }).then((res) => {
              this.isLoading = false
              if (Number(res.data.code) === 0) {
                this.$router.push('/login')
              }
            })
          } else {
            return false
          }
        })
      }
    },
    mounted () {
      this.getGenerateRSAPublicKey().then((res) => {
        this.publicKey = res.data.publicKey
      })
    }
  }
</script>
<style lang="scss">
  .user-operation__forget-password {
    @include userOperationBlockStyle;
  }

  .user-operation__forget-password-form {
    @include userOperationFormStyle;

    .el-radio__label {
      font-family: "FZLanTingHei-DB-GBK", "Microsoft YaHei";
      color: $lighterTrueBlack;
      font-size: 14px;
    }
  }

  .user-operation__sms-validate-code {
    @include resetBFC;
  }

  .user-operation__sms-button {
    //    @include vertical-center;
    position: absolute;
    top: 4px;
    right: 0;
    border-color: $lighterWaterBlue;
    background: $lighterWaterBlue;
    cursor: pointer;

    &:hover, &:active, &:focus {
      border-color: $lighterWaterBlue;
      background: $lighterWaterBlue;
    }

    &.is-loading {
      @include vertical-center;
    }
  }

  .user-operation__forget-password-submit {
    margin-top: 8px;
    border: 1px solid $orange;
    width: 100%;
    height: 45px;
    // line-height: 45px;
    // letter-spacing: 18px;
    font-size: 14px;
    background: $orange;

    &:hover, &:focus, &:active {
      border: 1px solid $orange;
      background: $orange;
    }

    & span {
      // margin-right: -18px; // letter spacing fix
    }
  }
</style>



// WEBPACK FOOTER //
// ForgetPassword.vue?dca7c8e2